module.exports = __webpack_public_path__ + "static/img/fashionjewelry.fb3f7d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/fashionjewelry.jpg
// module id = 5tkO
// module chunks = 1